import React from 'react';
import { Facebook, Twitter, Instagram } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function TopBar() {
  return (
    <div className="brand-gradient text-white text-xs">
      <div className="max-w-7xl mx-auto px-5 md:px-8 h-9 flex items-center justify-between">
        <div className="flex items-center gap-4">
          <a href="https://facebook.com" target="_blank" rel="noreferrer" aria-label="Facebook" className="hover:opacity-80 transition-opacity"><Facebook className="w-4 h-4" /></a>
          <a href="https://twitter.com" target="_blank" rel="noreferrer" aria-label="Twitter" className="hover:opacity-80 transition-opacity"><Twitter className="w-4 h-4" /></a>
          <a href="https://instagram.com" target="_blank" rel="noreferrer" aria-label="Instagram" className="hover:opacity-80 transition-opacity"><Instagram className="w-4 h-4" /></a>
          <span className="hidden md:inline opacity-90 tracking-wide">PT · Online Coaching · Group Sessions · Mum & Baby Groups</span>
        </div>
        <Link to="/contact" className="font-semibold uppercase tracking-[0.2em] border border-white/70 px-3 py-1 hover:bg-white hover:text-black transition-colors">
          Are You Ready?
        </Link>
      </div>
    </div>
  );
}
